import { render } from "./myFilesList.vue?vue&type=template&id=98fc1456"
import script from "./myFilesList.vue?vue&type=script&lang=js"
export * from "./myFilesList.vue?vue&type=script&lang=js"

import "./myFilesList.vue?vue&type=style&index=0&id=98fc1456&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__